import React, { Component } from 'react'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import Axios from 'axios';
import cachios from 'cachios';
import { BASE } from "../api/api";
import load from '../assets/loading.gif'
import smallload from '../assets/smallloader.gif'
import { Link } from 'react-router-dom'
import files from '../assets/file.png'
import trash from '../assets/trash.png'
import close from '../assets/iclose.png'
import OutsideClickHandler from 'react-outside-click-handler';
import ReactHtmlParser from 'react-html-parser';

class EditWork extends Component {
  constructor(props) {
    super(props);
    this.inputFile = React.createRef();
    this.updateFile = React.createRef();
    this.state = {
      error: false,
      invitepresent: false,
      load: false,
      select: 'Articles',
      stage: this.props.match.params.stage,
      journals: '',
      title: '',
      volume: '',
      number: '',
      year: '',
      pages: '',
      isbn: '',
      country: '',
      lang: '',
      abstract: '',
      url: '',
      lang2: 'en',
      place: '',
      edition: '',
      submit_for_work: '',
      degree: '',
      sdate: '',
      edate: '',
      token: '',
      uid: '',
      suggestlist: false,
      affiliationsselects: [],
      item_category1: [],
      university_college1: [],
      publisher1: [],
      descriptors1: [],
      biographiesselects: [],
      journals1: [],
      conference1: [],
      submit_for_work1: [],
      references1: [],
      workid: '',
      selectedauthor: [],
      selectedaffl: [],
      coaffls: [],
      authorarray: [""],
      paragraphsels: [],
      id: this.props.match.params.id
    }
  }
  // componentWillMount() {
  // }
  addCo(id) {
    let array = this.state.authorarray
    if (this.state.biographiesselects[id]) {
      array.push('')
      this.setState({
        authorarray: array,
        bioempty: false
      })
    }
    else {
      this.setState({
        bioempty: true
      })
    }
  }
  delCo(id) {
    let array = this.state.authorarray, bioarray = this.state.biographiesselects, afflarray = this.state.affiliationsselects, coafflarray = this.state.coaffls

    array.splice(id, 1);
    bioarray.splice(id, 1)
    afflarray.splice(id + 1, 1)
    coafflarray.splice(id, 1)
    this.setState({
      authorarray: array,
      coaffls: coafflarray,
      biographiesselects: bioarray,
      affiliationsselects: afflarray
    })
  }
  inviteco() {
    this.setState({
      invite: false,
      load: true
    })

    const body = {
      "data": {
        "type": "node--article",
        "attributes": {
          "title": this.state.title ? this.state.title : "",
          "body": {
            "value": this.state.body ? this.state.body : "",
            "format": "plain_text"
          },
          "field_confirm_email": this.state.conemail ? this.state.conemail : "",
          "field_email_id": this.state.email ? this.state.email : "",
          "field_first_name": this.state.fname ? this.state.fname : "",
          "field_surname": this.state.sname ? this.state.sname : ""
        }
      }
    }
    Axios.post(`${BASE}jsonapi/node/co_author`, body, {
      headers: {
        "Content-Type": "application/vnd.api+json",
        "Accept": "application/vnd.api+json",
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then(data => {
        console.log("add coauthor", data.data)
        this.addcoauth(data.data.data)
        this.setState({
          load: false
        })
      })
      .catch(err => {
        console.log("invite error", err.message)
        this.setState({
          load: false
        })
      })
  }
  signout() {
    localStorage.removeItem('token');
    localStorage.removeItem('expirytime');
    localStorage.removeItem('expiryref');
    this.props.history.push('/login?redir=/submit_your_work/select');

  }


  refreshexp() {
    let s = new Date();
    s.setSeconds(s.getSeconds() + 1800);
    localStorage.setItem('expiryref', s)
  }

  setselect(type) {
    this.handleChangeSelect(type)
    this.setState({
      select: type,
      showdrop: false
    })
  }
  checkexpiry() {
    if (localStorage.getItem('expiryref')) {
      let expref = Date.parse(localStorage.getItem('expiryref'))
      let s = new Date();
      if (s > expref) {
        this.fillalert('Session Expired!Logging Out')
        this.signout()
      }
      else {
        this.refreshexp()
      }

    }
    else {
      this.fillalert('Session Expired!Logging Out')
      this.signout()

    }
  }

  change(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  getAuthor() {
    Axios.get(`${BASE}jsonapi/user/user/${localStorage.getItem('uid')}`, {
      headers: {
        "Content-Type": "application/vnd.api+json",
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then(data => {
        console.log("user-details", data.data)
        this.setState({
          user: data.data.data,
          firstname: data.data.data.attributes.field_first_name,
          lname: data.data.data.attributes.field_last_name,
          target: data.data.data.attributes.drupal_internal__uid
        })
      })
      .catch(err => {
        console.log('user error', err.message)
      })
  }
  setnewfield(name, value, type) {
    this.setState({
      [name]: value,
      [type + 'sugg']: null,
      [type]: '',
    })
  }
  addcoauth(data) {
    this.setState({
      invitepresent: true
    })
    let authtype = "coauthor",
      title = `${data.attributes.field_surname}${data.attributes.field_first_name ? "," : ""}${data.attributes.field_first_name ? data.attributes.field_first_name : ""}`,
      id = data.id
    const selected = {
      "title": title,
      "id": id,
      "type": authtype
    }
    let boxarray = this.state.biographiesselects;
    boxarray.push(selected)
    this.setState({
      biographiesselects: boxarray,
    })
  }
  boxes3(uid, type) {
    if (type === "submit_for_work") {
      const name = type + '1';
      console.log('on clicking author sugg: uid=', uid, "type", type)
      let title = uid.attributes.title, id = uid.id
      const selected = {
        "title": title,
        "id": id
      }
      let boxarray = this.state[name];
      boxarray.push(selected)
      this.setState({
        [name]: boxarray,
      })

    }
    else {
      console.log('on clicking author sugg: uid=', uid, "type", type)
      const name = type + '1';
      let boxarray = this.state[name];
      const selected = {
        "title": uid._source.title ? uid._source.title[0] : uid._source.name_4[0],
        "id": uid._source.uuid_1 ? uid._source.uuid_1[0] : uid._source.uuid[0]
      }
      boxarray.push(selected)
      this.setState({
        [name]: boxarray,
        [type + 'sugg']: null,
        [type]: '',
      })
    }
    console.log(this.state.biographies1, 'xxxx')
  }
  boxes(item, type) {
    const name = type + '1';
    let boxarray = this.state[name];
    boxarray.push(item)
    this.setState({
      [name]: boxarray,
      [type + 'sugg']: null,
      [type]: '',
    })
    console.log(this.state.biographiesselects, 'xxxx')
    this.array(this.state.biographiesselects)
  }

  blur(type) {
    setTimeout(
      function () {
        this.setState({
          [type + 'sugg']: null,
          [type]: ''
        })
      }
        .bind(this),
      250
    );

  }

  remove(index, type) {
    const name = type + '1'
    let boxarray = this.state[name]; boxarray.splice(index, 1);
    this.setState({
      [name]: boxarray,
    })
  }
  removes(index, type) {
    const name = type + 'selects'
    let boxarray = this.state[name]; boxarray.splice(index, 1);
    this.setState({
      [name]: boxarray,
    })
  }
  removesco(index, type) {
    const name = type + 'selects'
    let boxarray = this.state[name], coaffl = this.state.coaffls;
    coaffl.splice(index, 1);
    boxarray.splice(index, 1);
    this.setState({
      [name]: boxarray,
      coaffls: coaffl
    })
  }
  handleA = (e) => {
    const name = e.target.name + 'sugg';
    this.setState({
      [e.target.name]: e.target.value,
      [name]: null
    })
    if (e.target.value !== '') {
      Axios.get(`${BASE}jsonapi/node/biographies?include=field_user_author&filter[name][condition][path]=title&filter[name][condition][operator]=CONTAINS&filter[name][condition][value]=${e.target.value}`)
        .then(data => {
          console.log("searched author", data.data.data)
          this.setState({
            [name]: data.data.data
          })
        })
    }
    else if ([e.target.name] === '') {
      this.setState({
        [name]: null
      })
    }

  }
  handleAffl2 = (e, type) => {
    const name = e.target.name + 'sugg';
    this.setState({
      [e.target.name]: e.target.value,
      [name]: null
    })
    if (e.target.value !== '') {


      if (type === "authors_search") {
        Axios.get(`${BASE}jsonapi/node/biographies?include=field_user_author&filter[name][condition][path]=title&filter[name][condition][operator]=CONTAINS&filter[name][condition][value]=${e.target.value}`)
          .then(data => {
            console.log("searched author", data.data.data)
            this.setState({
              [name]: data.data.data
            })
          })
      }
      else if (type === "publications_search") {
        console.log("book search")
        Axios.get(`${BASE}jsonapi/node/submit_for_work?filter[cis][condition][path]=field_cis_publications&filter[cis][condition][value]=1&filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][value]=Books&filter[title][condition][path]=title&filter[title][condition][path]=title&filter[title][condition][operator]=CONTAINS&filter[title][condition][value]=${e.target.value}`)
          .then(data => {
            console.log("searched author", data.data.data)
            this.setState({
              [name]: data.data.data
            })
          })
      }
      else {
        Axios(BASE + 'api/' + type + '?Keyword=' + e.target.value + '&from=0&size=10000', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        })
          .then((data) => {
            console.log('suggitems', data.data.hits.hits, 'name:', name)
            this.setState({
              [name]: data.data.hits.hits
            })
          })
      }

    }
    else if ([e.target.name] === '') {
      this.setState({
        [name]: null
      })
    }
  }
  handleChangeSelect = (e) => {
    this.clearform()
    this.clearalert()
    this.setState({
      select: e,
    })
    if (e === 'Theses') {
      this.setState({
        workid: this.state.worktypes[3].id
      })
    }
    else if (e === 'Books') {
      this.setState({
        workid: this.state.worktypes[1].id
      })
    }
    else if (e === 'Conferences') {
      this.setState({
        workid: this.state.worktypes[4].id
      })
    }
    else if (e === 'Book Chapters') {
      this.setState({
        workid: this.state.worktypes[2].id
      })
    }
    else if (e === 'Articles') {
      this.setState({
        workid: this.state.worktypes[0].id
      })
    }
    this.props.history.push('/submit_your_work/upload')
  }
  clearform() {
    this.setState({
      select: '',
      invitepresent: false,
      author: '',
      journal: '',
      title: '',
      volume: '',
      number: '',
      year: '',
      pages: '',
      isbn: '',
      country: '',
      lang: '',
      abstract: '',
      url: '',
      lang2: 'en',
      affiliations: '',
      reference: '',
      place: '',
      edition: '',
      book: '',
      instn: '',
      degree: '',
      sdate: '',
      edate: '',
      conf: '',
      affiliationsselects: [],
      item_category1: [],
      university_college1: [],
      publisher1: [],
      descriptors1: [],
      biographiesselects: [],
      journals1: [],
      conference1: [],
      submit_for_work1: [],
      references1: [],
      newaff: '',
      newauthor: '',
      newref: '',
      newbook: '',
      newpub: '',
      newjourn: '',
      newconf: '',
      newinst: ''

    })
  }



  checkrequired(name) {
    console.log('checking empty:', name)
    if (name === 'Theses') {
      if (this.state.year && this.state.abstract && this.state.country && this.state.lang && this.state.title && (this.state.university_college1.length !== 0 || this.state.newinst)) {
        return true
      }
      else {
        this.setState({
          titlealert: this.state.title ? null : true,
          yearalert: this.state.year ? null : true,
          countryalert: this.state.country ? null : true,
          langalert: this.state.lang ? null : true,
          newinstalert: this.state.university_college1.length !== 0 || this.state.newinst ? null : true,
          abstractalert: this.state.abstract ? null : true
        })
        this.topFunction();
        this.fillalert()

      }

    }

    else if (name === 'Books') {
      if (this.state.year && this.state.place && this.state.pages && this.state.affiliationsselects && this.state.country && this.state.lang2 && this.state.lang && this.state.title && this.state.isbn && (this.state.publisher1.length !== 0 || this.state.newpub)) {
        return true

      }
      else {
        this.setState({
          titlealert: this.state.title ? null : true,
          yearalert: this.state.year ? null : true,
          countryalert: this.state.country ? null : true,
          lang2alert: this.state.lang2 ? null : true,
          langalert: this.state.lang ? null : true,
          newpubalert: this.state.publisher1.length !== 0 || this.state.newpub ? null : true,
          isbnalert: this.state.isbn ? null : true,
          placealert: this.state.place ? null : true,
          pagealert: this.state.place ? null : true,
          afflalert: this.state.affiliationsselects ? null : true,
          abstractalert: this.state.abstract ? null : true

        })
        this.topFunction();
        this.fillalert()

      }

    }



    else if (name === 'Conferences') {
      if (this.state.year && this.state.place && this.state.country && this.state.lang2 && this.state.lang && this.state.title && (this.state.conference1.length !== 0 || this.state.newconf)) {
        return true

      }
      else {
        this.setState({
          titlealert: this.state.title ? null : true,
          yearalert: this.state.year ? null : true,
          countryalert: this.state.country ? null : true,
          lang2alert: this.state.lang2 ? null : true,
          langalert: this.state.lang ? null : true,
          newconfalert: this.state.conference1.length !== 0 || this.state.newconf ? null : true,
          placealert: this.state.place ? null : true,
          abstractalert: this.state.abstract ? null : true

        })
        this.topFunction();
        this.fillalert()


      }
    }

    else if (name === 'Book Chapters') {
      if (this.state.title && this.state.place && this.state.year && this.state.pages && this.state.country && this.state.isbn && this.state.lang && (this.state.publisher1.length !== 0 || this.state.newpub)) {
        return true
      }

      else {
        this.setState({
          titlealert: this.state.title ? null : true,
          placealert: this.state.place ? null : true,
          pagealert: this.state.pages ? null : true,
          yearalert: this.state.year ? null : true,
          countryalert: this.state.country ? null : true,
          langalert: this.state.lang ? null : true,
          isbnalert: this.state.isbn ? null : true,
          newpubalert: this.state.publisher1.length !== 0 || this.state.newpub ? null : true,
          abstractalert: this.state.abstract ? null : true

        })
      }
      this.topFunction();
      this.fillalert()

    }


    else if (name === 'Articles') {
      if (this.state.year && this.state.volume && this.state.number && this.state.pages && this.state.affiliationsselects && this.state.lang2 && this.state.title && (this.state.journals1.length !== 0 || this.state.newjourn)) {
        return true

      }
      else {
        this.setState({
          titlealert: this.state.title ? null : true,
          yearalert: this.state.year ? null : true,
          lang2alert: this.state.lang2 ? null : true,
          newjournalert: this.state.journals1.length !== 0 || this.state.newjourn ? null : true,
          volumealert: this.state.volume ? null : true,
          numberalert: this.state.number ? null : true,
          pagealert: this.state.pages ? null : true,
          afflalert: this.state.affiliationsselects ? null : true,
          abstractalert: this.state.abstract ? null : true

        })
        this.topFunction();
        this.fillalert()

      }

      // if (this.state.title) {

      //   if (this.state.journals1.length !== 0 || this.state.newjourn) {

      //     if (this.state.year) {

      //       if (this.state.country) {

      //         if (this.state.lang2) {

      //           if (this.state.lang) {

      //             return true
      //           }
      //           else
      //             alert('Please enter language')
      //         }
      //         else
      //           alert('Please enter record language')
      //       }
      //       else
      //         alert('Please enter country')
      //     }
      //     else
      //       alert('Please enter year')
      //   }
      //   else
      //     alert('Please enter Journal')
      // }
      // else
      //   alert('Please enter title')
    }
    else
      return true
  }

  authorcheck() {
    if (this.state.biographiesselects.length !== 0 || this.state.newauthor)
      return true
    else {
      this.setState({
        newauthoralert: this.state.biographiesselects.length !== 0 || this.state.newauthor ? null : true,
      })
      return false
    }
  }

  fillalert(msg) {
    this.setState({
      fillalert: true,
      filltext: msg ? msg : ''
    })
    setTimeout(
      function () {
        this.setState({
          fillalert: null,
          filltext: ''
        })
      }
        .bind(this),
      3000
    );
  }

  clearalert() {
    this.setState({
      titlealert: null,
      newauthoralert: null,
      langalert: null,
      lang2alert: null,
      yearalert: null,
      countryalert: null,
      isbnalert: null,
      newconfalert: null,
      newjournalert: null,
      newpubalert: null
    })
  }
  componentDidMount() {
    console.log(localStorage.getItem('token'), localStorage.getItem('uid'), 'token')
    if (localStorage.getItem('token') === null) {
      this.props.history.push(`/login?redir=/edit_your_work/${this.state.id}`);
    }
    console.log('id for edit', this.state.id)
    this.topFunction();
    if (this.props.match.params.id !== 'submit')
      this.setState({
        token: localStorage.getItem('token'),
        uid: localStorage.getItem('uid'),
        stage: 'form'
      })
    this.filledit(this.state.id)
    this.getAuthor()
    this.worktypes()
  }
  componentDidUpdate(prevProps) {
    if (this.props.match.params.id == 'submit') {
      setTimeout(() => {
        this.props.history.push('/')
      }, 5000)
    }
    if (this.props.match.params.id !== prevProps.match.params.id) {
      if (this.props.match.params.id == 'submit')
        this.setState({
          stage: this.props.match.params.id
        })
      else if (this.props.match.params.stage == 'edit')
        this.setState({
          stage: "form"
        })
      else {
        this.props.history.push('/404')
      }

    }
  }
  addCo(id) {
    let array = this.state.authorarray
    if (this.state.biographiesselects[id]) {
      array.push('')
      this.setState({
        authorarray: array,
        bioempty: false
      })
    }
    else {
      this.setState({
        bioempty: true
      })
    }
  }
  delCo(id) {
    let array = this.state.authorarray, bioarray = this.state.biographiesselects, afflarray = this.state.affiliationsselects

    array.splice(id, 1);
    bioarray.splice(id, 1)
    afflarray.splice(id + 1, 1)
    this.setState({
      authorarray: array
    })
  }
  addcoauth(data) {
    let authtype = "coauthor",
      title = data.attributes.field_first_name + "," + data.attributes.field_surname,
      id = data.id
    const selected = {
      "title": title,
      "id": id,
      "type": authtype
    }
    let boxarray = this.state.biographiesselects;
    boxarray.push(selected)
    this.setState({
      biographiesselects: boxarray,
    })
  }
  boxes2(uid, type) {
    const name = type + 'selects';
    if (type == "biographies") {
      let authtype = "author",
        title = uid.attributes.title,
        id = uid.id,
        userid = uid.relationships.field_user_author.data ? uid.relationships.field_user_author.data.id : null
      const selected = {
        "title": title,
        "id": id,
        "type": authtype,
        "userid": userid
      }
      let boxarray = this.state[name];
      boxarray.push(selected)
      this.setState({
        [name]: boxarray,
      })
    }
    else if (type == "coaffiliations") {
      let boxarray = this.state.affiliationsselects;
      let afflarray = this.state.coaffls
      const selected = {
        "title": uid._source.name_4[0],
        "id": uid._source.uuid_1[0]
      }
      afflarray.push(uid._source.name_4[0])
      boxarray.push(selected)
      this.setState({
        affiliationsselects: boxarray,
        coaffls: afflarray,
        ["affiliations" + 'sugg']: null,
        [type]: '',
      })
    }
    else {
      let boxarray = this.state[name];
      const selected = {
        "title": uid._source.name_4[0],
        "id": uid._source.uuid_1[0]
      }
      boxarray.push(selected)
      this.setState({
        [name]: boxarray,
        [type + 'sugg']: null,
        [type]: '',
      })
    }
    console.log('on clicking author sugg: uid=', uid, "type", type)
    console.log(this.state.biographiesselects, 'xxxx')
  }
  boxes(item, type) {
    const name = type + '1';
    let boxarray = this.state[name];
    boxarray.push(item)
    this.setState({
      [name]: boxarray,
      [type + 'sugg']: null,
      [type]: '',
    })
    console.log(this.state.biographiesselects, 'xxxx')
    this.array(this.state.biographiesselects)
  }

  blur(type) {
    setTimeout(
      function () {
        this.setState({
          [type + 'sugg']: null,
          [type]: ''
        })
      }
        .bind(this),
      250
    );

  }

  remove(index, type) {
    const name = type + '1'
    let boxarray = this.state[name]; boxarray.splice(index, 1);
    this.setState({
      [name]: boxarray,
    })
  }
  removes(index, type) {
    const name = type + 'selects'
    let boxarray = this.state[name]; boxarray.splice(index, 1);
    this.setState({
      [name]: boxarray,
    })
  }


  handleAffl = (e, type) => {
    const name = e.target.name + 'sugg';
    this.setState({
      [e.target.name]: e.target.value,
      [name]: null
    })
    if (e.target.value) {

      if (type == 'taxonomy_term') {
        Axios(BASE + '/jsonapi/' + type + '/' + e.target.name + '?filter[name][condition][path]=name&filter[name][condition][operator]=STARTS_WITH&filter[name][condition][value]=' + e.target.value + '&page[limit]=10', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        })
          .then((data) => {
            console.log(data, 'suggitems')
            this.setState({
              [name]: data.data.data
            })
          })
      }

      else {
        if (e.target.name !== 'references') {
          Axios(BASE + '/jsonapi/' + type + '/' + e.target.name + '?filter[title][condition][path]=title&filter[title][condition][operator]=STARTS_WITH&filter[title][condition][value]=' + e.target.value + '&page[limit]=10', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          })
            .then((data) => {
              console.log(data, 'suggitems')
              this.setState({
                [name]: data.data.data
              })
            })
        }
        else {
          Axios(BASE + '/jsonapi/' + type + '/submit_for_work?filter[title][condition][path]=title&filter[title][condition][operator]=STARTS_WITH&filter[title][condition][value]=' + e.target.value + '&page[limit]=10', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          })
            .then((data) => {
              console.log(data, 'suggitems')
              this.setState({
                [name]: data.data.data
              })
            })
        }
      }
    }
    else {
      this.setState({
        [type + 'sugg']: null
      })
    }


    // else{
    //   this.setState({
    //     [name]:null
    //   })
    // }

  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  radio(id) {
    this.setState({
      type: id
    })
  }

  worktypes() {
    cachios.get(BASE + 'jsonapi/taxonomy_term/submit_for_work_types', {
      ttl: 500 /* seconds */,
    })

      .then((data) => {

        this.setState({
          worktypes: data.data.data,
          workid: data.data.data[0].id
        })
        console.log(data, 'worktypes')

      })
      .catch(error => console.log(error, 'worktypes'));
  }


  validURL(myURL) {
    if (myURL === '') { return true }
    else {
      let pattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)+[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
      console.log(myURL, pattern)
      console.log(pattern.test(myURL))
      return pattern.test(myURL);
    }
  }

  array(value, type) {
    if (type === "node--biographies") {
      let array = value.map((value, index) => {
        if (value.type === "author")
          return ({
            "type": type,
            "id": value.id ? value.id : ""
          }
          )
      })
      console.log(array, 'xxxx')
      return array
    }
    else if (type === "node--co_author") {
      let array = value.map((value, index) => {
        if (value.type === "coauthor")
          return ({
            "type": type,
            "id": value.id ? value.id : ""
          }
          )
      })
      console.log(array, 'xxxx')
      return array
    }
    else if (type === "taxonomy_term--affiliations" || type === "node--submit_for_work") {
      let array = value.map((value, index) => {
        return ({
          "type": type,
          "id": value.id
        }
        )
      })
      console.log(array, 'xxxx')
      return array
    }
    else {
      let array = value.map((value, index) => {
        return ({
          "type": type,
          "id": value.id
        }
        )
      })
      console.log(array, 'abcdef', type)
      return array
    }
  }

  clearform() {
    this.setState({
      select: '',
      author: '',
      journal: '',
      title: '',
      volume: '',
      number: '',
      year: '',
      pages: '',
      isbn: '',
      country: '',
      lang: '',
      abstract: '',
      url: '',
      lang2: 'en',
      affiliations: '',
      reference: '',
      place: '',
      edition: '',
      book: '',
      instn: '',
      degree: '',
      sdate: '',
      edate: '',
      conf: '',
      affiliationsselects: [],
      item_category1: [],
      university_college1: [],
      publisher1: [],
      descriptors1: [],
      biographiesselects: [],
      journals1: [],
      conference1: [],
      submit_for_work1: [],
      references1: [],
      newaff: '',
      newauthor: '',
      newref: '',
      newbook: '',
      newpub: '',
      newjourn: '',
      newconf: '',
      newinst: ''

    })
  }
  authorcheck() {
    if (this.state.biographiesselects.length !== 0 || this.state.newauthor)
      return true
    else {
      this.setState({
        newauthoralert: this.state.biographiesselects.length !== 0 || this.state.newauthor ? null : true,
      })
      return false
    }
  }

  fillalert(msg) {
    this.setState({
      fillalert: true,
      filltext: msg ? msg : ''
    })
    setTimeout(
      function () {
        this.setState({
          fillalert: null,
          filltext: ''
        })
      }
        .bind(this),
      3000
    );
  }

  clearalert() {
    this.setState({
      titlealert: null,
      newauthoralert: null,
      langalert: null,
      lang2alert: null,
      yearalert: null,
      countryalert: null,
      isbnalert: null,
      newconfalert: null,
      newjournalert: null,
      newpubalert: null
    })
  }

  inviteco() {
    this.setState({
      invite: false,
      load: true
    })

    const body = {
      "data": {
        "type": "node--article",
        "attributes": {
          "title": this.state.title ? this.state.title : "",
          "body": {
            "value": this.state.body ? this.state.body : "",
            "format": "plain_text"
          },
          "field_confirm_email": this.state.conemail ? this.state.conemail : "",
          "field_email_id": this.state.email ? this.state.email : "",
          "field_first_name": this.state.fname ? this.state.fname : "",
          "field_surname": this.state.sname ? this.state.sname : ""
        }
      }
    }
    Axios.post(`${BASE}jsonapi/node/co_author`, body, {
      headers: {
        "Content-Type": "application/vnd.api+json",
        "Accept": "application/vnd.api+json",
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then(data => {
        console.log("add coauthor", data.data)
        this.addcoauth(data.data.data)
        this.setState({
          load: false
        })
      })
      .catch(err => {
        console.log("invite error", err.message)
        this.setState({
          load: false
        })
      })
  }
  filledit(id) {

    Axios.get(`${BASE}jsonapi/node/submit_for_work/${id}?include=uid,field_select_work_to_submit,field_author,field_invite_author,field_journal,field_publisher,field_affliations,field_books,field_conference,field_descriptors,field_institution,field_item_category,field_programe,field_full_text_pdf&filter[uid][condition][path]=uid.id&filter[uid][condition][value]=${localStorage.getItem('uid')}`,
      {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then(data => {
        console.log("work for edit", data.data)
        console.log("edit abstract", ReactHtmlParser(data.data.data.attributes.body.processed)[0].props.children[0])
        this.setState({
          works: data.data.data,
          title: data.data.data.attributes.title,
          lang2: data.data.data.attributes.langcode,
          abstract: data.data.data.attributes.body ? data.data.data.attributes.body.processed ? ReactHtmlParser(data.data.data.attributes.body.processed)[0].props.children[0] : "" : "",
          edate: data.data.data.attributes.field_conf_enddate,
          sdate: data.data.data.attributes.field_conf_start_date,
          country: data.data.data.attributes.field_country,
          degree: data.data.data.attributes.field_degree,
          edition: data.data.data.attributes.field_edition,
          isbn: data.data.data.attributes.field_isbn,
          lang: data.data.data.attributes.field_language,
          number: data.data.data.attributes.field_number,
          pages: data.data.data.attributes.field_pages,
          place: data.data.data.attributes.field_place,
          volume: data.data.data.attributes.field_volume,
          url: data.data.data.attributes.field_website ? data.data.data.attributes.field_website.uri : "",
          year: data.data.data.attributes.field_year,
          newaff: data.data.data.attributes.field_other_affiliation,
          newauthor: data.data.data.attributes.field_other_author,
          newref: data.data.data.attributes.field_other_references,
          newpub: data.data.data.attributes.field_other_publisher,
          newjourn: data.data.data.attributes.field_other_journal,
          newinst: data.data.data.attributes.field_other_institution,
          newconf: data.data.data.attributes.field_other_conference,
          newbook: data.data.data.attributes.field_other_books_title,
          included: data.data.included
        })
        if (data.data.data.relationships.field_select_work_to_submit.data) {
          if (data.data.included.filter(x => x.id === data.data.data.relationships.field_select_work_to_submit.data.id)[0].attributes.name === "Thesis") {
            this.setState({
              workid: data.data.data.relationships.field_select_work_to_submit.data.id,
              select: "Theses"

            })
          }
          else
            this.setState({
              workid: data.data.data.relationships.field_select_work_to_submit.data.id,
              select: data.data.included.filter(x => x.id === data.data.data.relationships.field_select_work_to_submit.data.id)[0].attributes.name

            })
          if (data.data.data.relationships.field_author.data.length) {
            let i, authors = [], authorarrays = this.state.authorarray, ids = [], authtype = "author"
            for (i = 0; i < data.data.data.relationships.field_author.data.length; i++) {
              const selected = {
                "title": data.data.included.filter(x => x.id === data.data.data.relationships.field_author.data[i].id)[0].attributes.title,
                "id": data.data.data.relationships.field_author.data[i].id,
                "type": authtype
              }
              console.log("selected of", i, "=", selected)
              authors.push(selected)
              if (i != 0)
                authorarrays.push("")
            }
            this.setState({
              biographiesselects: authors,
              authorarray: authorarrays
            }, () => {
              console.log("biographies from edit", this.state.biographiesselects)
              if (data.data.data.relationships.field_invite_author.data) {
                let i, authors = this.state.biographiesselects, authorarrays = this.state.authorarray, ids = [], authtype = "author"
                const selected = {
                  "title": data.data.included.filter(x => x.id === data.data.data.relationships.field_invite_author.data.id)[0].attributes.title,
                  "id": data.data.data.relationships.field_invite_author.data.id,
                  "type": "coauthor"
                }
                console.log("selected coauth of", i, "=", selected)
                authors.push(selected)
                authorarrays.push("")
                this.setState({
                  biographiesselects: authors,
                  authorarray: authorarrays
                }, () => {
                  console.log("biographies from edit", this.state.biographiesselects)
                })
              }
            })
          }
          if (data.data.data.relationships.field_affliations.data.length) {
            let i, authors = [], author, ids = [], coafl = [], type = ""
            for (i = 0; i < data.data.data.relationships.field_affliations.data.length; i++) {
              if (i == 0) {
                type = `affl`
              }
              else {
                type = `coaffl${i - 1}`
              }
              const selected = {
                "title": data.data.included.filter(x => x.id === data.data.data.relationships.field_affliations.data[i].id)[0].attributes.name,
                "id": data.data.data.relationships.field_affliations.data[i].id,
                "type": type
              }
              author = data.data.included.filter(x => x.id === data.data.data.relationships.field_affliations.data[i].id)[0].attributes.name
              authors.push(selected)
              ids.push()
              console.log("affliation for edit", author)
            }
            console.log("co affliation for edit", coafl)
            this.setState({
              affiliationsselects: authors,
              coaffls: coafl
            })
          }
          if (data.data.data.relationships.field_journal.data) {
            let title = data.data.included.filter(x => x.id === data.data.data.relationships.field_journal.data.id)[0].attributes.title,
              id = data.data.data.relationships.field_journal.data.id, journals = []
            const selected = {
              "title": title,
              "id": id
            }
            journals.push(selected)
            this.setState({
              journals1: journals
            })
          }
          if (data.data.data.relationships.field_publisher.data) {
            let title = data.data.included.filter(x => x.id === data.data.data.relationships.field_publisher.data.id)[0].attributes.name,
              id = data.data.data.relationships.field_publisher.data.id, journals = []
            console.log("publishers get", title)
            const selected = {
              "title": title,
              "id": id
            }
            journals.push(selected)
            this.setState({
              publisher1: journals
            })
          }
          if (data.data.data.relationships.field_books.data) {
            let title = data.data.included.filter(x => x.id === data.data.data.relationships.field_books.data.id)[0].attributes.title,
              id = data.data.data.relationships.field_books.data.id, journals = []
            console.log("books get", title)
            const selected = {
              "title": title,
              "id": id
            }
            journals.push(selected)
            this.setState({
              submit_for_work1: journals
            })
          }
          if (data.data.data.relationships.field_books.data) {
            let title = data.data.included.filter(x => x.id === data.data.data.relationships.field_books.data.id)[0].attributes.title,
              id = data.data.data.relationships.field_books.data.id, journals = []
            console.log("books get", title)
            const selected = {
              "title": title,
              "id": id
            }
            journals.push(selected)
            this.setState({
              submit_for_work1: journals
            })
          }
          if (data.data.data.relationships.field_institution.data.length) {
            let i, authors = [], author, ids = [], authtype = "author"
            for (i = 0; i < data.data.data.relationships.field_institution.data.length; i++) {
              const selected = {
                "title": data.data.included.filter(x => x.id === data.data.data.relationships.field_institution.data[i].id)[0].attributes.name,
                "id": data.data.data.relationships.field_institution.data[i].id
              }
              console.log("institution of", i, "=", selected)
              authors.push(selected)
            }
            this.setState({
              university_college1: authors,
            })
          }
          if (data.data.data.relationships.field_conference.data) {
            let title = data.data.included.filter(x => x.id === data.data.data.relationships.field_conference.data.id)[0].attributes.title,
              id = data.data.data.relationships.field_conference.data.id, journals = []
            console.log("books get", title)
            const selected = {
              "title": title,
              "id": id
            }
            journals.push(selected)
            this.setState({
              conference1: journals
            })
          }
          if (data.data.data.relationships.field_full_text_pdf.data.length) {
            let title = data.data.included.filter(x => x.id === data.data.data.relationships.field_full_text_pdf.data[0].id)[0].attributes.filename,
              id = data.data.data.relationships.field_full_text_pdf.data[0].id, journals = []
            this.props.history.push(`/edit_your_work/${this.state.id}?upload=${id}&upname=${title}`)
            console.log("pdf get", title)
          }
          //data.relationships.field_books.data
          //data.relationships.field_journal.data
          // if(this.state.worktypes){

          // }
        }
      })
      .catch(err => {
        console.log('Get work error:', err.message)
      })
  }
  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  async paragraph(value, type) {
    let returndata
    let array = await value.map((val, index) => {
      if (val.userid) {
        console.log("paragraph calling api")
        const data = {
          "data": {
            "type": "paragraph--author_data",
            "attributes": {
              "parent_type": "node",
              "parent_field_name": "field_author_information",
              "field_published": false
            },
            "relationships": {
              "field_author_name": {
                "data": {
                  "type": "node--biographies",
                  "id": val.id
                }
              },
              "field_author_user_name": {
                "data": {
                  "type": "user--user",
                  "id": val.userid
                }
              }

            }
          }
        }
        console.log("its happening")
        let para = this.state.paragraphsels
        Axios.post(`${BASE}jsonapi/paragraph/author_data`, data, {
          headers: {
            "Authorization": `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/vnd.api+json",
            "Accept": "application/vnd.api+json"
          }
        })
          .then(res => {

            const returndata = {
              "type": res.data.data.type,
              "id": res.data.data.id,
              "meta": {
                "target_revision_id": res.data.data.attributes.drupal_internal__id
              }
            }
            console.log("paragraph return data", returndata)
            para.push(returndata)
            this.setState({
              paragraphsels: para
            })
          })
          .catch((err) => {
            this.setState({
              load: false
            })
            console.log(err)

            if (err.response.status === 422) {
              console.log(err.response)
              alert(err.response.data.errors[0].detail)
            }
            else if (err.response.status === 500) {
              console.log(err)

            }
            else if (err.response.status === 403) {
              alert('Session Expired.Please Login')
              localStorage.removeItem('token');
              this.props.history.push('/login?redir=/submit_your_work/select')
            }
          })
      }
      else {

      }
    }
    )
    console.log("paragraph array", value, "after:", this.state.paragraphsels)
    return true
  }
  async submit(e) {
    try {
      e.preventDefault();
      let array = this.state.biographiesselects.filter(function (img) {
        if (!img.userid) {
          return false; // skip
        }
        return true;
      }).map((val, index) => {
        return new Promise((resolve, reject) => {
          const data = {
            "data": {
              "type": "paragraph--author_data",
              "attributes": {
                "parent_type": "node",
                "parent_field_name": "field_author_information",
                "field_published": false
              },
              "relationships": {
                "field_author_name": {
                  "data": {
                    "type": "node--biographies",
                    "id": val.id
                  }
                },
                "field_author_user_name": {
                  "data": {
                    "type": "user--user",
                    "id": val.userid
                  }
                }

              }
            }
          }
          Axios.post(`${BASE}jsonapi/paragraph/author_data`, data, {
            headers: {
              "Authorization": `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/vnd.api+json",
              "Accept": "application/vnd.api+json"
            }
          })
            .then(res => {
              let para = this.state.paragraphsels
              const returndata = {
                "type": res.data.data.type,
                "id": res.data.data.id,
                "meta": {
                  "target_revision_id": res.data.data.attributes.drupal_internal__id
                }
              }
              console.log("paragraph return data", returndata)
              para.push(returndata)
              resolve(returndata)
              this.setState({
                paragraphsels: para
              })
            })
            .catch((err) => {
              this.setState({
                load: false
              })
              console.log(err)

              if (err.response.status === 422) {
                console.log(err.response)
                alert(err.response.data.errors[0].detail)
              }
              else if (err.response.status === 500) {
                console.log(err)

              }
              else if (err.response.status === 403) {
                alert('Session Expired.Please Login')
                localStorage.removeItem('token');
                this.props.history.push('/login?redir=/submit_your_work/select')
              }
            })
        });
      })
      Promise.all(array).then((response) => {
        console.log("final promise", response)
        if (this.checkrequired(this.state.select)) {

          if (this.state.title) {
            // if (this.state.biographiesselects.length !== 0 || this.state.newauthor) {

            if (this.validURL(this.state.url)) {
              if (this.state.select) {
                this.setState({
                  load: true
                })

                const formbody = {
                  "data": {
                    "type": "node--submit_for_work",
                    "id": `${this.state.id}`,
                    "attributes": {
                      "title": this.state.title,
                      "langcode": this.state.lang2,
                      "body": this.state.abstract ? this.state.abstract : null,
                      "field_conf_enddate": this.state.edate ? this.state.edate : null,
                      "field_conf_start_date": this.state.sdate ? this.state.sdate : null,
                      "field_country": this.state.country ? this.state.country : null,
                      "field_degree": this.state.degree ? this.state.degree : null,
                      "field_edition": this.state.edition ? this.state.edition : null,
                      "field_isbn": this.state.isbn ? this.state.isbn : null,
                      "field_language": this.state.lang ? this.state.lang : null,
                      "field_number": this.state.number ? this.state.number : null,
                      "field_pages": this.state.pages ? this.state.pages : null,
                      "field_place": this.state.place ? this.state.place : null,
                      "field_volume": this.state.volume ? this.state.volume : null,
                      "field_website": this.state.url ? this.state.url : null,
                      "field_year": this.state.year ? this.state.year : null,
                      "field_other_affiliation": this.state.newaff ? this.state.newaff : null,
                      "field_other_author": this.state.newauthor ? this.state.newauthor : null,
                      "field_other_references": this.state.newref ? this.state.newref : null,
                      "field_other_publisher": this.state.newpub ? this.state.newpub : null,
                      "field_other_journal": this.state.newjourn ? this.state.newjourn : null,
                      "field_other_institution": this.state.newinst ? this.state.newinst : null,
                      "field_other_conference": this.state.newconf ? this.state.newconf : null,
                      "field_other_books_title": this.state.newbook ? this.state.newbook : null
                    },
                    "relationships": {
                      "uid": {
                        "data": {
                          "type": "user--user",
                          "id": this.state.uid
                        }
                      },
                      "field_select_work_to_submit": {
                        "data": {
                          "type": "taxonomy_term--submit_for_work_types",
                          "id": this.state.workid
                        }
                      },
                      "field_affliations": {
                        "data": this.array(this.state.affiliationsselects, "taxonomy_term--affiliations")
                      },
                      "field_invite_author": {
                        "data": this.state.invitepresent ? this.array(this.state.biographiesselects, "node--co_author") : null,
                      },
                      "field_author": {
                        "data": this.array(this.state.biographiesselects, "node--biographies")
                      },
                      "field_books": {
                        "data": this.array(this.state.submit_for_work1, "node--submit_for_work")
                      },
                      "field_conference": {
                        "data": this.array(this.state.conference1, "node--conference")
                      },
                      "field_institution": {
                        "data": this.array(this.state.university_college1, "taxonomy_term--university_college")
                      },
                      "field_journal": {
                        "data": this.array(this.state.journals1, "node--journals")
                      },
                      "field_publisher": {
                        "data": this.array(this.state.publisher1, "taxonomy_term--publisher")
                      },
                      "field_references": {
                        "data": this.array(this.state.references1, "node--submit_for_work")
                      },
                      "field_author_information": {
                        "data": response
                      },
                      "field_full_text_pdf": new URLSearchParams(this.props.location.search).get("upload") !== null ? {
                        "data": {
                          "type": "file--document",
                          "id": new URLSearchParams(this.props.location.search).get("upload")
                        }
                      }
                        : null
                    },
                    "type": "node--submit_for_work"
                  }
                }
                Axios(`${BASE}jsonapi/node/submit_for_work/${this.state.id}`, {
                  method: "PATCH",
                  headers: {
                    'Authorization': "Bearer " + this.state.token,
                    'Content-Type': 'application/vnd.api+json',
                    'Accept': 'application/vnd.api+json'
                  },
                  data: formbody
                })

                  .then((res) => {
                    this.setState({
                      load: false
                    })
                    this.clearform()
                    this.clearalert()
                    this.fillalert('Your work is submitted')
                    console.log(res, 'response')
                    this.props.history.push('/submit_your_work/submit')
                  })
                  .catch((err) => {
                    this.setState({
                      load: false
                    })
                    console.log(err)

                    if (err.response.status === 422) {
                      console.log(err.response)
                      alert(err.response.data.errors[0].detail)
                    }
                    else if (err.response.status === 500) {
                      console.log(err)

                    }
                    else if (err.response.status === 403) {
                      alert('Session Expired.Please Login')
                      localStorage.removeItem('token');
                      this.props.history.push('/login?redir=/submit_your_work/select')
                    }
                  })
                // })
                // .catch((error) => {
                //   console.log(error)
                // })
              }
              else {
                alert("Please select the type")
              }
            }

            else {
              alert('Enter valid URL')
            }
          }
          //   else {
          //     alert('Enter the Author')
          //   }
          // }
          else {
            alert('Enter the title')
          }
        }
      })
    }
    catch (err) {
      console.log("error on try", err)
    }
  }
  selectFiles() {
    this.updateFile.current.click();
  }
  handleFile(event) {
    const history = this.props.history
    const stop = this
    event.stopPropagation();
    event.preventDefault();
    let selectedFile = event.target.files;
    let file = null;
    let fileName = "";
    let target = this.state.target
    this.setState({
      load: true
    })
    //Check File is not Empty
    if (selectedFile.length > 0) {
      // Select the very first file from list
      let fileToLoad = selectedFile[0];
      fileName = fileToLoad.name;
      // FileReader function for read the file.
      let fileReader = new FileReader();
      // Onload of file read the file content
      fileReader.onload = function (fileLoadedEvent) {
        file = fileLoadedEvent.target.result.split(',')[1];
        // Print data in console
        console.log('file to upload', file);
        const formbody = {
          "_links": {
            "type": {
              "href": "http://ibir-api.hbku.edu.qa/rest/type/file/document"
            }
          },
          "filename": [
            {
              "value": fileName
            }
          ],
          "filemime": {
            "value": "document/pdf"
          },
          "uid": [
            {
              "target_id": target,
              "target_type": "user",
              "target_uuid": localStorage.getItem('uid'),
              "url": "/user/806"
            }
          ],
          "uri": [
            {
              "value": `public://${fileName}`
            }
          ],
          "type": {
            "target_id": "file"
          },
          "data": [
            {
              "value": file
            }
          ]
        }
        Axios({
          url: BASE + "entity/file?_format=hal_json",
          method: "POST",
          headers: {
            "X-CSRF-Token": "Isqh8xGZPB7Pf8kW8mY7eyQWLNaXGebdRCcU1XPK3LA",
            "Content-Type": "application/hal+json",
            "Authorization": "Bearer " + localStorage.getItem("token"),
          },
          data: formbody
        }).then((data) => {
          stop.setState({
            load: false
          })
          console.log('upload done', data.data.uuid[0].value)
          history.push(`/edit_your_work/${stop.state.id}?upload=${data.data.uuid[0].value}&upname=${data.data.filename[0].value}`)
        }).catch((data) => {
          stop.setState({
            load: false
          })
          if (data.response.status === 403) {
            alert('Session Expired.Please Login')
            localStorage.removeItem('token');
            this.props.history.push(`/login?redir=/edit_your_work/${this.state.id}`);
          }
          else {
            console.log('error upload', data.message)
            alert(data.message)
          }
        })
      };
      // Convert data to base64
      fileReader.readAsDataURL(fileToLoad);
    }
    console.log('file after convert', file, ",name:", fileName);
    this.setState({
      fileData: file,
      fileName: fileName
    })
    this.setState({
      file: file
    }
      // , 
      // () => {
      //   this.props.history.push('/submit_your_work/form')
      // }
    );
  }
  render() {
    return (
      <div className='formrea yourwork' style={{ backgroundColor: this.state.stage === 'form' ? '#E5E5E5' : '' }}>
        {this.state.load ? <div className='loading'>
          <img src={load} alt='load' />
        </div> : ''}
        {this.state.fillalert ? <div className={this.state.filltext === 'Your work is Edited' ? "fill-alert fill-success" : "fill-alert"}>{this.state.filltext ? this.state.filltext : 'Please enter all mandatory fields'}</div> : ''}
        <Header />
        <div className="listing" style={{ backgroundColor: this.state.stage === 'form' ? '#E5E5E5' : '' }}>
          <div className="main-content">
            <div className="container">
              <div className="row">
                <div className="region region-content">
                  <form className="webform-client-form webform-client-form-275" id="webform-client-form-275" accept-charset="UTF-8">
                    <div>
                      <div className="form-component">
                        {this.state.stage == 'select' ?
                          // <select name="select" onChange={e => this.handleChangeSelect(e)} value={this.state.select}>
                          //   <option value="" disabled selected>Select</option>
                          //   <option value="Articles">Articles</option>
                          //   <option value="Books">Books</option>
                          //   <option value="Book Chapters">Book Chapters</option>
                          //   <option value="Theses">Theses</option>
                          //   <option value="Conferences">Conferences</option>
                          // </select>
                          <div className='select-container'>
                            <h1 className="title">Submit Your Work</h1>
                            {this.state.stage == 'select' ? <p for="edit-submitted-name" className='edit-submitted-name'>Select type of work to submit :</p> : ""}
                            <div className='submit-types'>
                              <div className='single-type' onClick={() => this.handleChangeSelect('Articles')} >
                                <img src={process.env.PUBLIC_URL + '/submit/Articles.png'} />
                                <p>Articles</p>
                              </div>
                              <div className='single-type' onClick={() => this.handleChangeSelect('Books')}>
                                <img src={process.env.PUBLIC_URL + '/submit/Books.png'} />
                                <p>Books</p>
                              </div>
                              <div className='single-type' onClick={() => this.handleChangeSelect('Book Chapters')}>
                                <img src={process.env.PUBLIC_URL + '/submit/Book Chapters.png'} />
                                <p>Book Chapters</p>
                              </div>
                              <div className='single-type' onClick={() => this.handleChangeSelect('Theses')}>
                                <img src={process.env.PUBLIC_URL + '/submit/Theses.png'} />
                                <p>Theses</p>
                              </div>
                              <div className='single-type' onClick={() => this.handleChangeSelect('Conferences')}>
                                <img src={process.env.PUBLIC_URL + '/submit/Conferences.png'} />
                                <p>Conference Paper</p>
                              </div>
                            </div>
                          </div>
                          : ''}

                      </div>
                      {this.state.stage == 'upload' ? <div className='upload-container'>
                        <div className='title'>Add research to your profile</div>
                        <div className='upload-box'>
                          <p className='do-want'>Do you want to add a file?</p>
                          <div className='upload-select' onClick={() => this.selectFile()}>
                            <div className='upload-select-datas'>
                              <input type='file' id='file' ref={this.inputFile} accept="application/pdf" style={{ display: 'none' }} onChange={(e) => this.handleFile(e)} />
                              <img src={process.env.PUBLIC_URL + '/submit/upload.png'} />
                              <p className='select-text'>Select and upload file</p>
                            </div>
                          </div>
                          <div className='skip-box'>
                            <p className='skip-desc'>You can add details about this research in the next step</p>
                            <p role='button' onClick={() => this.skip_upload()} className='skip-btn'>Skip</p>
                          </div>
                        </div>
                      </div> : ''}
                      {this.state.stage == 'submit' ? <div className='submitted-container'>

                        <div className='thank-img'>
                          <img src={process.env.PUBLIC_URL + '/submit/Group.png'} />
                        </div>
                        <div className='thanks-main'>Thank You</div>
                        <p className='thanks-sub'>Your work was edited successfully</p>
                        <div className='thanks-sub-sub'>
                          <p >You will be redirected to the home page shortly</p>
                          <p >or <Link to='/'>click here to home page now</Link></p>
                        </div>
                      </div> : ''}
                      {this.state.stage ? this.state.stage == 'form' ? <div className='form-title'>Submit Your Work</div> : '' : ''}
                      {this.state.stage ? this.state.stage == 'form' ? <div id="submit-fields">
                        <div className='row change-select'>
                          <p for="edit-submitted-name" className='edit-submitted-name-select' onClick={() => { this.setState({ showdrop: true }) }}>Select type of work to submit:
                            <span> {this.state.select} <img onClick={() => this.setState({ showdrop: true })} src={process.env.PUBLIC_URL + '/submit/down.png'} /></span>
                          </p>
                          {this.state.showdrop ? <OutsideClickHandler onOutsideClick={() => this.setState({ showdrop: false })}> <div className='drop-select'>
                            <p value="Articles" onClick={() => { this.clearform(); this.clearalert(); this.setState({ showdrop: false, select: 'Articles', workid: this.state.worktypes[0].id }) }}>Articles</p>
                            <p value="Books" onClick={() => { this.clearform(); this.clearalert(); this.setState({ showdrop: false, select: 'Books', workid: this.state.worktypes[1].id }) }}>Books</p>
                            <p value="Book Chapters" onClick={() => { this.clearform(); this.clearalert(); this.setState({ showdrop: false, select: 'Book Chapters', workid: this.state.worktypes[2].id }) }}>Book Chapters</p>
                            <p value="Theses" onClick={() => { this.clearform(); this.clearalert(); this.setState({ showdrop: false, select: 'Theses', workid: this.state.worktypes[3].id }) }}>Theses</p>
                            <p value="Conferences" onClick={() => { this.clearform(); this.clearalert(); this.setState({ showdrop: false, select: 'Conferences', workid: this.state.worktypes[4].id }) }}>Conference Paper</p>
                          </div></OutsideClickHandler> : ''}
                        </div>
                        <label for="edit-submitted-email">Author <span className="form-required" title="This field is required.">{this.state.select === 'Book Chapters' ? '*' : '*'}</span></label>
                        <div className='row' style={{ marginBottom: 0 }}>

                          <div className="form-component">
                            <input id="email" name="firstname" type="text" value={this.state.firstname}
                              onChange={e => this.handleChange(e)} disabled />
                          </div>
                          <div className="form-component">
                            <input id="email" name="lname" type="text" value={this.state.lname}
                              onChange={e => this.handleChange(e)} disabled />
                          </div>
                        </div>
                        <div className="form-component">
                          <label for="edit-submitted-email">Title <span className="form-required" title="This field is required.">{this.state.select === 'Book Chapters' ? '*' : '*'}</span></label>
                          <input id="email" name="title" type="text" value={this.state.title}
                            onChange={e => this.handleChange(e)} />
                          {this.state.titlealert && !this.state.title ? <div class="alert-tag">The <strong>Title</strong> cannot be empty</div> : null}
                        </div>
                        {this.state.select === 'Articles' ? <div>
                          <div className="form-component">
                            <label for="edit-submitted-email">Volume <span className="form-required" title="This field is required.">{this.state.select === 'Articles' ? '*' : '*'}</span></label>
                            <input id="email" name="volume" type="text" value={this.state.volume}
                              onChange={e => this.handleChange(e)} />
                            {this.state.volumealert && !this.state.volume ? <div class="alert-tag"><strong>Volume</strong> cannot be empty</div> : null}


                          </div>
                          <div className="form-component">
                            <label for="edit-submitted-email">Issue <span className="form-required" title="This field is required.">{this.state.select === 'Articles' ? '*' : '*'}</span></label>
                            <input id="email" name="number" type="text" value={this.state.number}
                              onChange={e => this.handleChange(e)} />
                            {this.state.numberalert && !this.state.number ? <div class="alert-tag"><strong>Issue</strong> cannot be empty</div> : null}


                          </div>
                        </div> : ''}
                        {this.state.select === 'Books' || this.state.select === 'Book Chapters' ? <div>
                          <div className="form-component">
                            <label for="edit-submitted-email">Publisher<span className="form-required" title="This field is required.">{this.state.select === 'Book Chapters' ? '*' : '*'}</span></label>

                            <div className='suggest-container'>
                              {/* name boxes */}
                              <div class="vR">
                                <span class="vN bfK a3q">
                                  {this.state.publisher1 != [] ? this.state.publisher1.map((list, index) => {
                                    return (
                                      <div class="vT">{list.title}<div onClick={() => this.remove(index, 'publisher')} className='vC'></div></div>

                                    )
                                  }) : ''
                                  }
                                  {this.state.newpub ?
                                    <div class="vT">{this.state.newpub}<div onClick={() => this.setState({ newpub: '' })} className='vC'></div></div>
                                    : ''
                                  }
                                </span>
                              </div>
                              {/* input */}
                              <div className="relative">
                                <textarea onBlur={() => this.blur('publisher')} disabled={this.state.publisher1.length === 1 ? true : false} id="email" name="publisher" type="text" value={this.state.publisher}
                                  onChange={e => { this.handleAffl2(e, 'publisher_search') }} />
                                <img style={{ display: this.state.publisher && !this.state.publishersugg ? '' : 'none' }} src={smallload} alt='load' />
                              </div>
                              {/* suggest list */}
                              {this.state.publishersugg ? this.state.publishersugg.length != 0 ? <ul className='suggestlist'>

                                {this.state.publishersugg.map((list, index) => {
                                  return (
                                    <li onClick={() => this.boxes3(list, 'publisher')}>{list._source.name_4[0]}</li>

                                  )
                                })}
                              </ul>
                                : '' : ''}
                              {this.state.publisher ? <button className="addnewitem" onClick={() => this.setnewfield('newpub', this.state.publisher, 'publisher')} >ADD NEW</button> : ''}
                            </div>
                            {this.state.newpubalert ? this.state.publisher1.length === 0 && !this.state.newpub ? <div class="alert-tag">The <strong>Publisher</strong> cannot be empty</div> : null : null}

                          </div>

                          <div className="form-component">
                            <label for="edit-submitted-email">Edition <span className="form-required" title="This field is required."></span></label>
                            <input id="email" name="edition" type="text" value={this.state.edition}
                              onChange={e => this.handleChange(e)} />


                          </div>
                        </div> : ''}
                        {this.state.select === 'Book Chapters' ? <div>

                          <div className="form-component">
                            <label for="edit-submitted-email">Book Title <span className="form-required" title="This field is required.">{this.state.select === 'Book Chapters' ? '*' : ''}</span></label>


                            <div className='suggest-container'>
                              {/* name boxes */}
                              <div class="vR">
                                <span class="vN bfK a3q">
                                  {this.state.submit_for_work1 != [] ? this.state.submit_for_work1.map((list, index) => {
                                    return (
                                      <div class="vT">{list.title}<div onClick={() => this.remove(index, 'submit_for_work')} className='vC'></div></div>
                                    )
                                  }) : ''
                                  }
                                  {this.state.newbook ?
                                    <div class="vT">{this.state.newbook}<div onClick={() => this.setState({ newbook: '' })} className='vC'></div></div>
                                    : ''
                                  }
                                </span>
                              </div>
                              {/* input */}
                              <div className="relative">

                                <textarea onBlur={() => this.blur('submit_for_work')} disabled={this.state.submit_for_work1.length === 1 ? true : false} id="email" name="submit_for_work" type="text" value={this.state.submit_for_work}
                                  onChange={e => { this.handleAffl2(e, 'publications_search') }} />
                                <img style={{ display: this.state.submit_for_work && !this.state.submit_for_worksugg ? '' : 'none' }} src={smallload} alt='load' />
                              </div>
                              {/* suggest list */}
                              {this.state.submit_for_worksugg ? this.state.submit_for_worksugg.length != 0 ? <ul className='suggestlist'>
                                {this.state.submit_for_worksugg.map((list, index) => {
                                  return (
                                    <li onClick={() => this.boxes3(list, 'submit_for_work')}>{list.attributes.title}</li>
                                  )
                                })}
                              </ul>
                                : '' : ''}
                              {this.state.submit_for_work ? <button className="addnewitem" onClick={() => this.setnewfield('newbook', this.state.submit_for_work, 'submit_for_work')} >Add New</button> : ''}

                            </div>
                          </div>
                        </div> : ''}

                        {this.state.select === 'Theses' ? <div>

                          {/* <div className="form-component">
                            <label for="edit-submitted-email">Degree <span className="form-required" title="This field is required.">{this.state.select === 'Book Chapters' ? '' : '*'}</span></label>
                            <input id="email" name="degree" type="text" value={this.state.degree}
                              onChange={e => this.handleChange(e)} />
                            {this.state.degreealert && !this.state.degree ? <div class="alert-tag">The <strong>Degree</strong> cannot be empty</div> : null}
                          </div> */}

                          <div className="form-component">
                            <label for="edit-submitted-email">Institution<span className="form-required" title="This field is required.">{this.state.select === 'Book Chapters' ? '' : '*'}</span></label>


                            <div className='suggest-container'>
                              {/* name boxes */}
                              <div class="vR">
                                <span class="vN bfK a3q">
                                  {this.state.university_college1 != [] ? this.state.university_college1.map((list, index) => {
                                    return (
                                      <div class="vT">{list.title}<div onClick={() => this.remove(index, 'university_college')} className='vC'></div></div>

                                    )
                                  }) : ''
                                  }
                                  {this.state.newinst ?
                                    <div class="vT">{this.state.newinst}<div onClick={() => this.setState({ newinst: '' })} className='vC'></div></div>
                                    : ''
                                  }
                                </span>
                              </div>
                              {/* input */}
                              <div className="relative">
                                <textarea onBlur={() => this.blur('university_college')} id="email" name="university_college" type="text" value={this.state.university_college}
                                  onChange={e => { this.handleAffl2(e, 'university_college_search') }} />
                                <img style={{ display: this.state.university_college && !this.state.university_collegesugg ? '' : 'none' }} src={smallload} alt='load' />
                              </div>
                              {/* suggest list */}
                              {this.state.university_collegesugg ? this.state.university_collegesugg.length != 0 ? <ul className='suggestlist'>

                                {this.state.university_collegesugg.map((list, index) => {
                                  return (
                                    <li onClick={() => this.boxes3(list, 'university_college')}>{list._source.name_4[0]}</li>

                                  )
                                })}
                              </ul>
                                : '' : ''}
                              {this.state.university_college ? <button className="addnewitem" onClick={() => this.setnewfield('newinst', this.state.university_college, 'university_college')} >Add New</button> : ''}

                            </div>
                            {this.state.newinstalert ? this.state.university_college1.length === 0 && !this.state.newinst ? <div class="alert-tag">The <strong>Institution</strong> cannot be empty</div> : null : null}

                          </div>
                        </div>

                          : ''}
                        {this.state.select !== 'Theses' ?

                          <div className="form-component affl-author">
                            <label for="edit-submitted-email">Affiliation (Author) <span className="form-required" title="This field is required.">{this.state.select === 'Articles' || this.state.select === 'Books' ? '*' : ''}</span></label>
                            <div className='suggest-container'>
                              {/* name boxes */}
                              <div class="vR">
                                <span class="vN bfK a3q" email="muddasir009@gmail.com" data-hovercard-id="muddasir009@gmail.com">
                                  {this.state.affiliationsselects != [] ? this.state.affiliationsselects.map((list, index) => {
                                    if (list.type === "affl")
                                      return (
                                        <div class="vT">{list.title}<div onClick={() => this.removesco(index, 'affiliations')} className='vC'></div></div>

                                      )
                                  }) : ''
                                  }
                                  {this.state.newaff ?
                                    <div class="vT">{this.state.newaff}<div onClick={() => this.setState({ newaff: '' })} className='vC'></div></div>
                                    : ''
                                  }
                                </span>
                              </div>

                              {/* input */}
                              <div className="relative">
                                <textarea disabled={this.state.newaff || this.state.affiliationsselects[0]} onBlur={() => this.blur('affiliations')} id="email" name="affiliations" type="text" value={this.state.affiliations}
                                  onChange={e => { this.handleAffl2(e, 'affiliations_search') }} />
                                <img style={{ display: this.state.affiliations && !this.state.affiliationssugg ? '' : 'none' }} src={smallload} alt='load' />
                              </div>
                              {/* suggest list */}
                              {this.state.affiliationssugg ? this.state.affiliationssugg.length != 0 ? this.state.affiliationsselects.length < 2 ? <ul className='suggestlist'>

                                {this.state.affiliationssugg.map((list, index) => {
                                  return (
                                    <li onClick={() => this.boxes2(list, 'affiliations')}>{list._source.name_4[0]}</li>

                                  )
                                })}
                              </ul>
                                : '' : '' : ""}
                              {this.state.affiliations ? <button className="addnewitem" onClick={() => this.setnewfield('newaff', this.state.affiliations, 'affiliations')} >Add New</button> : ''}

                            </div>
                            {this.state.afflalert && !this.state.affiliationsselects[0] ? <div class="alert-tag"><strong>Affiliation</strong> cannot be empty</div> : null}

                          </div>
                          : ''}
                        {/* Co authors rows */}
                        { }
                        {this.state.select !== 'Theses' ?
                          this.state.authorarray.length ? this.state.authorarray.map((data, indeces) => {
                            let names = 'biographies' + indeces, suggs = 'biographies' + indeces + 'sugg', afflname = "coaffiliation" + indeces, afflsugg = 'coaffiliation' + indeces + 'sugg'

                            return (
                              <div>
                                <div className='row co-author-row' style={{ marginBottom: 0 }}>
                                  <div className="form-component">
                                    <label for="edit-submitted-email">Co author </label>
                                    <div className='suggest-container'>
                                      {/* {this.state.affiliationsselects[indeces + 1] && !this.state.biographiesselects[indeces] ? <div class="unselect" /> : ""} */}
                                      {/* name boxes */}
                                      <div class="vR">
                                        <span class="vN bfK a3q" email="muddasir009@gmail.com" data-hovercard-id="muddasir009@gmail.com">
                                          {this.state.biographiesselects.length ? this.state.biographiesselects.map((list, index) => {
                                            if (index === indeces)
                                              return (
                                                <div class="vT">{list.title}<div onClick={() => this.removes(index, 'biographies')} className='vC'></div></div>

                                              )
                                          }) : ''
                                          }
                                          {this.state.newauthor ?
                                            <div class="vT">{this.state.newauthor}<div onClick={() => this.setState({ newauthor: '' })} className='vC'></div></div>
                                            : ''
                                          }
                                        </span>
                                      </div>
                                      {/* input */}
                                      {/* onBlur={()=>this.blur('biographies')} */}
                                      <div className="relative">
                                        <textarea id="email" disabled={this.state.biographiesselects[indeces]} name={names} type="text" onBlur={() => this.blur(names)} value={this.state[names]}
                                          onChange={e => { this.handleA(e) }} />
                                        <img style={{ display: this.state.biographies && !this.state.biographiessugg || this.state.biographiesload ? '' : 'none' }} src={smallload} alt='load' />
                                      </div>
                                      {/* suggest list */}
                                      {this.state[suggs] ? this.state[suggs].length !== 0 ? <ul className='suggestlist'>

                                        {this.state[suggs].map((list, index) => {
                                          return (
                                            <li onClick={() => this.boxes2(list, 'biographies')}>{list.attributes.title}</li>

                                          )
                                        })}
                                      </ul>

                                        : '' : ''}
                                      {/* {this.state[names] ? <button className="addnewitem" onClick={() => this.setnewfield('newauthor', this.state[names], names)} >Add New</button> : ''} */}
                                      {this.state[names] ? <div className="addnewitem pointer" onClick={() => this.setState({ invite: true })} >Add New</div> : ''}
                                    </div>
                                  </div>
                                  <div className="form-component">
                                    <label for="edit-submitted-email">Affiliation (Co-Author)</label>
                                    <div className='suggest-container'>
                                      {/* {!this.state.affiliationsselects[indeces + 1] && this.state.biographiesselects[indeces] ? <div class="unselect" /> : ""} */}
                                      {/* name boxes */}
                                      <div class="vR">
                                        <span class="vN bfK a3q b" email="muddasir009@gmail.com" data-hovercard-id="muddasir009@gmail.com">
                                          {this.state.affiliationsselects.length ? this.state.affiliationsselects.map((list, index) => {
                                            if (list.type === `coaffl${indeces}`)
                                              return (
                                                <div class="vT">{list.title}<div onClick={() => this.removesco(index, 'affiliations')} className='vC'></div></div>

                                              )
                                          }) : ''
                                          }
                                        </span>
                                      </div>

                                      {/* input */}
                                      <div className="relative">
                                        <textarea onBlur={() => this.blur('affiliations')} id="email" disabled={this.state.affiliationsselects[indeces + 1]} name={afflname} type="text" value={this.state[afflname]}
                                          onChange={e => { this.handleAffl2(e, 'affiliations_search') }} />
                                        <img style={{ display: this.state.affiliations && !this.state.affiliationssugg ? '' : 'none' }} src={smallload} alt='load' />
                                      </div>
                                      {/* suggest list */}
                                      {this.state[afflsugg] ? this.state[afflsugg].length != 0 ? <ul className='suggestlist'>

                                        {this.state[afflsugg].map((list, index) => {
                                          return (
                                            <li onClick={() => { this.boxes2(list, 'coaffiliations'); this.setState({ [afflname]: '', [afflsugg]: null }) }}>{list._source.name_4[0]}</li>

                                          )
                                        })}
                                      </ul>
                                        : '' : ''}
                                      {this.state.coaffiliations ? <button className="addnewitem" onClick={() => this.setnewfield('newaff', this.state.affiliations, 'affiliations')} >Add New</button> : ''}

                                    </div>
                                    {this.state.afflalert && !this.state.affiliations ? <div class="alert-tag"><strong>Affiliation</strong> cannot be empty</div> : null}

                                  </div>
                                  {indeces != 0 ? <div className="pointer delCo" onClick={() => this.delCo(indeces)}>X</div> : ""}
                                </div>
                                {this.state.select !== 'Theses' ? this.state.authorarray.length === indeces + 1 ? this.state.bioempty ? <div className="alert-tag">Co author cannot be empty</div> : "" : "" : ""}

                                {this.state.select !== 'Theses' ? this.state.authorarray.length === indeces + 1 ? <div className='add-co pointer' onClick={() => this.addCo(indeces)}>Add Co-author</div> : "" : ""}
                              </div>
                            )
                          }) : ""
                          : ''}
                        {this.state.select === 'Conferences' ? <div>

                          <div className="form-component">
                            <label for="edit-submitted-email">Conference <span className="form-required" title="This field is required.">{this.state.select === 'Book Chapters' ? '' : '*'}</span></label>


                            <div className='suggest-container'>
                              {/* name boxes */}
                              <div class="vR">
                                <span class="vN bfK a3q">
                                  {this.state.conference1 != [] ? this.state.conference1.map((list, index) => {
                                    return (
                                      <div class="vT">{list.title}<div onClick={() => this.remove(index, 'conference')} className='vC'></div></div>

                                    )
                                  }) : ''
                                  }
                                  {this.state.newconf ?
                                    <div class="vT">{this.state.newconf}<div onClick={() => this.setState({ newconf: '' })} className='vC'></div></div>
                                    : ''
                                  }
                                </span>
                              </div>
                              {/* input */}
                              <div className="relative">
                                <textarea onBlur={() => this.blur('conference')} disabled={this.state.conference1.length === 1 ? true : false} id="email" name="conference" type="text" value={this.state.conference}
                                  onChange={e => { this.handleAffl2(e, 'conference_search') }} />
                                <img style={{ display: this.state.conference && !this.state.conferencesugg ? '' : 'none' }} src={smallload} alt='load' />

                              </div>
                              {/* suggest list */}
                              {this.state.conferencesugg ? this.state.conferencesugg.length != 0 ? <ul className='suggestlist'>

                                {this.state.conferencesugg.map((list, index) => {
                                  return (
                                    <li onClick={() => this.boxes3(list, 'conference')}>{list._source.title[0]}</li>
                                  )
                                })}
                              </ul>
                                : this.state.conference ? <button className="addnewitem" onClick={() => this.setnewfield('newconf', this.state.conference, 'conference')} >Add New</button> : '' : ''}
                              {this.state.conference ? <button className="addnewitem" onClick={() => this.setnewfield('newconf', this.state.conference, 'conference')} >Add New</button> : ''}
                            </div>
                            {this.state.newconfalert ? this.state.conference1.length === 0 && !this.state.newconf ? <div class="alert-tag">The <strong>Conference</strong> cannot be empty</div> : null : null}

                          </div>
                        </div> : ''}

                        {this.state.select === 'Articles' ?

                          <div className="form-component">
                            <label for="edit-submitted-email">Journal <span className="form-required" title="This field is required.">{this.state.select === 'Book Chapters' ? '' : '*'}</span></label>


                            <div className='suggest-container'>
                              {/* name boxes */}
                              <div class="vR">
                                <span class="vN bfK a3q">
                                  {this.state.journals1 != [] ? this.state.journals1.map((list, index) => {
                                    console.log('title of journal', list)
                                    return (
                                      <div class="vT">{list.title}<div onClick={() => this.remove(index, 'journals')} className='vC'></div></div>
                                    )
                                  }) : ''
                                  }
                                  {this.state.newjourn ?
                                    <div class="vT">{this.state.newjourn}<div onClick={() => this.setState({ newjourn: '' })} className='vC'></div></div>
                                    : ''
                                  }
                                </span>
                              </div>
                              {/* input */}
                              <div className="relative">
                                <textarea disabled={this.state.journals1.length === 1 ? true : false} onBlur={() => this.blur('journals')} id="email" name="journals" type="text" value={this.state.journals}
                                  onChange={e => { this.handleAffl2(e, 'journals_search') }} />
                                <img style={{ display: this.state.journals && !this.state.journalssugg ? '' : 'none' }} src={smallload} alt='load' />

                              </div>
                              {/* suggest list */}
                              {this.state.journalssugg ? this.state.journalssugg.length != 0 ? <ul className='suggestlist'>

                                {this.state.journalssugg.map((list, index) => {
                                  return (
                                    <li onClick={() => this.boxes3(list, 'journals')}>{list._source.title[0]}</li>
                                  )
                                })}
                              </ul>
                                : '' : ''}
                              {this.state.journals ? <button className="addnewitem" onClick={() => this.setnewfield('newjourn', this.state.journals, 'journals')} >Add New</button> : ''}

                            </div>
                            {this.state.newjournalert ? this.state.journals1.length === 0 && !this.state.newjourn ? <div class="alert-tag">The <strong>Journal</strong> cannot be empty</div> : null : null}

                          </div>

                          : ''}
                        <div className={this.state.select !== 'Theses' ? 'row row-of-3' : 'row'}>
                          <div className="form-component">
                            <label for="edit-submitted-email">Year <span className="form-required" title="This field is required.">{this.state.select === 'Book Chapters' ? '*' : '*'}</span></label>
                            <input id="email" name="year" type="number" onKeyDown={ (evt) => (evt.key === 'e' || evt.key === 'E') && evt.preventDefault() } value={this.state.year}
                              onChange={e => this.handleChange(e)} />
                            {this.state.yearalert && !this.state.year ? <div class="alert-tag">The <strong>Year</strong> cannot be empty</div> : null}
                          </div>
                          {this.state.select === 'Conferences' ? <div className="form-component">
                            <label for="edit-submitted-email">Conf. Start Date	 <span className="form-required" title="This field is required."></span></label>
                            <input id="email" name="sdate" type="date" value={this.state.sdate}
                              onChange={e => this.handleChange(e)} />
                          </div> : ''}
                          {this.state.select === 'Conferences' ?
                            <div className="form-component">
                              <label for="edit-submitted-email">Conf. End Date	 <span className="form-required" title="This field is required."></span></label>
                              <input id="email" name="edate" type="date" value={this.state.edate}
                                onChange={e => this.handleChange(e)} />
                            </div> : ''}
                          {this.state.select != 'Conferences' ?
                            <div className="form-component">
                              <label for="edit-submitted-email">Pages <span className="form-required" title="This field is required.">{this.state.select === 'Articles' || this.state.select === 'Books' || this.state.select === 'Book Chapters' ? '*' : ''}</span></label>
                              <input id="email" placeholder={this.state.select === 'Books' ? "Enter total no of pages only" : "12-34"} name="pages" type="text" value={this.state.pages}
                                onChange={e => this.handleChange(e)} />
                              {this.state.pagealert && !this.state.pages ? <div class="alert-tag"><strong>Pages</strong> cannot be empty</div> : null}


                            </div> : ''}

                          {this.state.select === 'Books' || this.state.select === 'Book Chapters' || this.state.select === 'Articles' ? <div className="form-component">
                            <label for="edit-submitted-email">{this.state.select === 'Articles' ? "ISSN " : 'ISBN '} <span className="form-required" title="This field is required.">{this.state.select === 'Articles' ? '*' : '*'}</span></label>
                            <input id="email" name="isbn" type="text" value={this.state.isbn}
                              onChange={e => this.handleChange(e)} />
                            {this.state.isbnalert && !this.state.isbn ? <div class="alert-tag">The <strong>ISBN</strong> cannot be empty</div> : null}
                          </div> : ''}
                        </div>
                        {this.state.select === 'Books' || this.state.select === 'Book Chapters' || this.state.select === 'Conferences' ? <div>

                          <div className="form-component">
                            <label for="edit-submitted-email">Place <span className="form-required" title="This field is required.">{this.state.select === 'Books' || this.state.select === 'Book Chapters' || this.state.select === 'Conferences' ? '*' : ''}</span></label>
                            <div>
                              <input id="email" name="place" type="text" value={this.state.place}
                                onChange={e => this.handleChange(e)} />
                              {this.state.placealert && !this.state.place ? <div class="alert-tag"><strong>Place</strong> cannot be empty</div> : null}

                            </div>

                          </div>
                        </div> : ''}
                        <div className='row'>
                          <div className="form-component" style={{ width: '50%' }}>
                            <label for="edit-submitted-name">Country <span className="form-required" title="This field is required.">{this.state.select === 'Articles' ? '' : '*'}</span></label>
                            <select name="country" onChange={e => this.handleChange(e)} value={this.state.country}>
                              <option value="" disabled selected>Select</option>
                              <option value="AF">Afghanistan</option><option value="AL">Albania</option><option value="DZ">Algeria</option><option value="AS">American Samoa</option><option value="AD">Andorra</option><option value="AO">Angola</option><option value="AI">Anguilla</option><option value="AQ">Antarctica</option><option value="AG">Antigua and Barbuda</option><option value="AR">Argentina</option><option value="AM">Armenia</option><option value="AW">Aruba</option><option value="AC">Ascension Island</option><option value="AU">Australia</option><option value="AT">Austria</option><option value="AZ">Azerbaijan</option><option value="BS">Bahamas</option><option value="BH">Bahrain</option><option value="BD">Bangladesh</option><option value="BB">Barbados</option><option value="BY">Belarus</option><option value="BE">Belgium</option><option value="BZ">Belize</option><option value="BJ">Benin</option><option value="BM">Bermuda</option><option value="BT">Bhutan</option><option value="BO">Bolivia</option><option value="BA">Bosnia and Herzegovina</option><option value="BW">Botswana</option><option value="BV">Bouvet Island</option><option value="BR">Brazil</option><option value="IO">British Indian Ocean Territory</option><option value="VG">British Virgin Islands</option><option value="BN">Brunei</option><option value="BG">Bulgaria</option><option value="BF">Burkina Faso</option><option value="BI">Burundi</option><option value="KH">Cambodia</option><option value="CM">Cameroon</option><option value="CA">Canada</option><option value="IC">Canary Islands</option><option value="CV">Cape Verde</option><option value="BQ">Caribbean Netherlands</option><option value="KY">Cayman Islands</option><option value="CF">Central African Republic</option><option value="EA">Ceuta and Melilla</option><option value="TD">Chad</option><option value="CL">Chile</option><option value="CN">China</option><option value="CX">Christmas Island</option><option value="CP">Clipperton Island</option><option value="CC">Cocos [Keeling] Islands</option><option value="CO">Colombia</option><option value="KM">Comoros</option><option value="CG">Congo - Brazzaville</option><option value="CD">Congo - Kinshasa</option><option value="CK">Cook Islands</option><option value="CR">Costa Rica</option><option value="HR">Croatia</option><option value="CU">Cuba</option><option value="CW">Curaçao</option><option value="CY">Cyprus</option><option value="CZ">Czech Republic</option><option value="CI">Côte d’Ivoire</option><option value="DK">Denmark</option><option value="DG">Diego Garcia</option><option value="DJ">Djibouti</option><option value="DM">Dominica</option><option value="DO">Dominican Republic</option><option value="EC">Ecuador</option><option value="EG">Egypt</option><option value="SV">El Salvador</option><option value="GQ">Equatorial Guinea</option><option value="ER">Eritrea</option><option value="EE">Estonia</option><option value="ET">Ethiopia</option><option value="FK">Falkland Islands</option><option value="FO">Faroe Islands</option><option value="FJ">Fiji</option><option value="FI">Finland</option><option value="FR">France</option><option value="GF">French Guiana</option><option value="PF">French Polynesia</option><option value="TF">French Southern Territories</option><option value="GA">Gabon</option><option value="GM">Gambia</option><option value="GE">Georgia</option><option value="DE">Germany</option><option value="GH">Ghana</option><option value="GI">Gibraltar</option><option value="GR">Greece</option><option value="GL">Greenland</option><option value="GD">Grenada</option><option value="GP">Guadeloupe</option><option value="GU">Guam</option><option value="GT">Guatemala</option><option value="GG">Guernsey</option><option value="GN">Guinea</option><option value="GW">Guinea-Bissau</option><option value="GY">Guyana</option><option value="HT">Haiti</option><option value="HM">Heard Island and McDonald Islands</option><option value="HN">Honduras</option><option value="HK">Hong Kong SAR China</option><option value="HU">Hungary</option><option value="IS">Iceland</option><option value="IN">India</option><option value="ID">Indonesia</option><option value="IR">Iran</option><option value="IQ">Iraq</option><option value="IE">Ireland</option><option value="IM">Isle of Man</option><option value="IL">Israel</option><option value="IT">Italy</option><option value="JM">Jamaica</option><option value="JP">Japan</option><option value="JE">Jersey</option><option value="JO">Jordan</option><option value="KZ">Kazakhstan</option><option value="KE">Kenya</option><option value="KI">Kiribati</option><option value="XK">Kosovo</option><option value="KW">Kuwait</option><option value="KG">Kyrgyzstan</option><option value="LA">Laos</option><option value="LV">Latvia</option><option value="LB">Lebanon</option><option value="LS">Lesotho</option><option value="LR">Liberia</option><option value="LY">Libya</option><option value="LI">Liechtenstein</option><option value="LT">Lithuania</option><option value="LU">Luxembourg</option><option value="MO">Macau SAR China</option><option value="MK">Macedonia</option><option value="MG">Madagascar</option><option value="MW">Malawi</option><option value="MY">Malaysia</option><option value="MV">Maldives</option><option value="ML">Mali</option><option value="MT">Malta</option><option value="MH">Marshall Islands</option><option value="MQ">Martinique</option><option value="MR">Mauritania</option><option value="MU">Mauritius</option><option value="YT">Mayotte</option><option value="MX">Mexico</option><option value="FM">Micronesia</option><option value="MD">Moldova</option><option value="MC">Monaco</option><option value="MN">Mongolia</option><option value="ME">Montenegro</option><option value="MS">Montserrat</option><option value="MA">Morocco</option><option value="MZ">Mozambique</option><option value="MM">Myanmar [Burma]</option><option value="NA">Namibia</option><option value="NR">Nauru</option><option value="NP">Nepal</option><option value="NL">Netherlands</option><option value="AN">Netherlands Antilles</option><option value="NC">New Caledonia</option><option value="NZ">New Zealand</option><option value="NI">Nicaragua</option><option value="NE">Niger</option><option value="NG">Nigeria</option><option value="NU">Niue</option><option value="NF">Norfolk Island</option><option value="MP">Northern Mariana Islands</option><option value="KP">North Korea</option><option value="NO">Norway</option><option value="OM">Oman</option><option value="QO">Outlying Oceania</option><option value="PK">Pakistan</option><option value="PW">Palau</option><option value="PS">Palestinian Territories</option><option value="PA">Panama</option><option value="PG">Papua New Guinea</option><option value="PY">Paraguay</option><option value="PE">Peru</option><option value="PH">Philippines</option><option value="PN">Pitcairn Islands</option><option value="PL">Poland</option><option value="PT">Portugal</option><option value="PR">Puerto Rico</option><option value="QA">Qatar</option><option value="RO">Romania</option><option value="RU">Russia</option><option value="RW">Rwanda</option><option value="RE">Réunion</option><option value="BL">Saint Barthélemy</option><option value="SH">Saint Helena</option><option value="KN">Saint Kitts and Nevis</option><option value="LC">Saint Lucia</option><option value="MF">Saint Martin</option><option value="PM">Saint Pierre and Miquelon</option><option value="VC">Saint Vincent and the Grenadines</option><option value="WS">Samoa</option><option value="SM">San Marino</option><option value="SA">Saudi Arabia</option><option value="SN">Senegal</option><option value="RS">Serbia</option><option value="SC">Seychelles</option><option value="SL">Sierra Leone</option><option value="SG">Singapore</option><option value="SX">Sint Maarten</option><option value="SK">Slovakia</option><option value="SI">Slovenia</option><option value="SB">Solomon Islands</option><option value="SO">Somalia</option><option value="ZA">South Africa</option><option value="GS">South Georgia and the South Sandwich Islands</option><option value="KR">South Korea</option><option value="SS">South Sudan</option><option value="ES">Spain</option><option value="LK">Sri Lanka</option><option value="SD">Sudan</option><option value="SR">Suriname</option><option value="SJ">Svalbard and Jan Mayen</option><option value="SZ">Swaziland</option><option value="SE">Sweden</option><option value="CH">Switzerland</option><option value="SY">Syria</option><option value="ST">São Tomé and Príncipe</option><option value="TW">Taiwan</option><option value="TJ">Tajikistan</option><option value="TZ">Tanzania</option><option value="TH">Thailand</option><option value="TL">Timor-Leste</option><option value="TG">Togo</option><option value="TK">Tokelau</option><option value="TO">Tonga</option><option value="TT">Trinidad and Tobago</option><option value="TA">Tristan da Cunha</option><option value="TN">Tunisia</option><option value="TR">Turkey</option><option value="TM">Turkmenistan</option><option value="TC">Turks and Caicos Islands</option><option value="TV">Tuvalu</option><option value="UM">U.S. Outlying Islands</option><option value="VI">U.S. Virgin Islands</option><option value="UG">Uganda</option><option value="UA">Ukraine</option><option value="AE">United Arab Emirates</option><option value="GB">United Kingdom</option><option value="US">United States</option><option value="UY">Uruguay</option><option value="UZ">Uzbekistan</option><option value="VU">Vanuatu</option><option value="VA">Vatican City</option><option value="VE">Venezuela</option><option value="VN">Vietnam</option><option value="WF">Wallis and Futuna</option><option value="EH">Western Sahara</option><option value="YE">Yemen</option><option value="ZM">Zambia</option><option value="ZW">Zimbabwe</option><option value="AX">Åland Islands</option>
                            </select>
                            {this.state.countryalert && !this.state.country ? <div class="alert-tag">The <strong>Country</strong> cannot be empty</div> : null}
                          </div>
                          <div className="form-component" style={{ width: '48%' }}>
                            <label for="edit-submitted-name">Language of Publication <span className="form-required" title="This field is required.">{this.state.select === 'Articles' ? '' : '*'}</span></label>
                            <select name="lang" onChange={e => this.handleChange(e)} value={this.state.lang}>
                              <option value="" disabled selected>Select</option>
                              <option value="Arabic">Arabic</option><option value="Arabic/English">Arabic/English</option><option value="Arabic/French">Arabic/French</option><option value="Danish">Danish</option><option value="English">English</option><option value="English and French">English and French</option><option value="English and German">English and German</option><option value="English and Italian">English and Italian</option><option value="English and Urdu">English and Urdu</option><option value="French">French</option><option value="German">German</option><option value="Indonesian">Indonesian</option><option value="Indonesian and Arabic">Indonesian and Arabic</option><option value="Indonesian and English">Indonesian and English</option><option value="Italian">Italian</option><option value="Japanese">Japanese</option><option value="Japanese/English">Japanese/English</option><option value="Malaysian">Malaysian</option><option value="Persian">Persian</option><option value="Russian">Russian</option><option value="Serbo-Croatian">Serbo-Croatian</option><option value="Tamil">Tamil</option><option value="Turkish">Turkish</option><option value="Urdu">Urdu</option>
                            </select>
                            {this.state.langalert && !this.state.lang ? <div class="alert-tag">The <strong>Language</strong> cannot be empty</div> : null}
                          </div>
                        </div>
                        <div className="form-component">
                          <label for="edit-submitted-email">Abstract <span className="form-required" title="This field is required.">{'*'}</span></label>
                          <textarea id="email" name="abstract" type="text" value={this.state.abstract} className='abstract'
                            onChange={e => this.handleChange(e)} />
                          <span style={{ display: this.state.error && !this.state.city ? '' : 'none' }} className="popuptext" id="myPopup">Please fill in this field</span>
                          {this.state.abstractalert && !this.state.abstract ? <div class="alert-tag"><strong>Abstract</strong> cannot be empty</div> : null}

                        </div>
                        <div className="form-component">
                          <label for="edit-submitted-email">URL <span className="form-required" title="This field is required."></span></label>
                          <input id="email" name="url" type="text" value={this.state.url}
                            onChange={e => this.handleChange(e)} />


                        </div>
                        {/* <div className="form-component">
                          <input type='file' id='file' ref={this.updateFile} accept="application/pdf" style={{ display: 'none' }} onChange={(e) => this.handleFile(e)} />

                          <div className='form-upload-btn cursor' onClick={() => this.selectFiles()}><span> <img src={editup} /> </span>  Upload</div>
                        </div> */}
                        {new URLSearchParams(this.props.location.search).get("upname") ? <div className='uploaded-file'>
                          <img src={files} />
                          <p>{new URLSearchParams(this.props.location.search).get("upname")}</p>
                          <img src={trash} className='pointer' onClick={() => this.props.history.push(`/edit_your_work/${this.state.id}`)} />
                        </div> :
                          <div className="form-component">
                            <div className='upload-select-datas pointer' onClick={() => this.selectFiles()}>
                              <input type='file' id='file' ref={this.updateFile} accept="application/pdf" style={{ display: 'none' }} onChange={(e) => this.handleFile(e)} />
                              <img src={process.env.PUBLIC_URL + '/submit/upload.png'} />
                              <p className='select-text'>Select and upload file</p>
                            </div>
                          </div>
                        }
                        {/* <div className="form-component">
                          <label for="edit-submitted-email">Reference <span className="form-required" title="This field is required."></span></label>


                          <div className='suggest-container'>
                           
                            <div class="vR">
                              <span class="vN bfK a3q">
                                {this.state.references1 != [] ? this.state.references1.map((list, index) => {
                                  return (
                                    <div class="vT">{list._source.title[0]}<div onClick={() => this.remove(index, 'references')} className='vC'></div></div>

                                  )
                                }) : ''
                                }
                                {this.state.newref ?
                                  <div class="vT">{this.state.newref}<div onClick={() => this.setState({ newref: '' })} className='vC'></div></div>
                                  : ''
                                }
                              </span>
                            </div>
                         
                            <div className="relative">
                              <textarea onBlur={() => this.blur('references')} id="email" name="references" type="text" value={this.state.references}
                                onChange={e => { this.handleAffl2(e, 'publications_search') }} />
                              <img style={{ display: this.state.references && !this.state.referencessugg ? '' : 'none' }} src={smallload} alt='load' />
                            </div>
                           
                            {this.state.referencessugg ? this.state.referencessugg.length != 0 ? <ul className='suggestlist'>

                              {this.state.referencessugg.map((list, index) => {
                                return (
                                  <li onClick={() => this.boxes2(list, 'references')}>{list._source.title[0]}</li>

                                )
                              })}
                            </ul>
                              : '' : ''}
                            {this.state.references ? <button className="addnewitem" onClick={() => this.setnewfield('newref', this.state.references, 'references')} >Add New</button> : ''}

                          </div>
                        </div> */}
                        {/* <div className="form-component">
                          <label for="edit-submitted-name">Record Language <span className="form-required" title="This field is required.">{this.state.select === 'Book Chapters' ? '' : '*'}</span></label>
                          <select name="lang2" onChange={e => this.handleChange(e)} value={this.state.lang2}>
                            <option value="" disabled selected>Select</option>
                            <option value="ar">Arabic</option>
                            <option value="en">English</option>
                          </select>
                          {this.state.lang2alert && !this.state.lang2 ? <div class="alert-tag">The <strong>Record Language</strong> cannot be empty</div> : null}
                        </div> */}
                        <div className='your-submit' onClick={e => this.submit(e)}>Submit</div>
                      </div> : '' : ''}

                      {/* <div  className="form-component form-component-textarea">
                            <label for="edit-submitted-message">Detailed Question <span className="form-required" title="This field is required.">{this.state.select==='Book Chapters'?'':'*'}</span></label>
                            <div className="form-textarea-wrapper resizable"><textarea id="msg" name="msg" type="text"  value={this.state.msg}
                                  onChange={e => this.handleChange(e)}   cols="60" rows="5" className="form-textarea required"></textarea></div>
                              <span style={{display:this.state.error&&!this.state.msg?'':'none'}} className="popuptext" id="myPopup">Please fill in this field</span>
          
                          </div> */}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          {this.state.invite ?
            <div className="invite">
              <img className='close pointer' onClick={() => this.setState({ invite: false })} src={close} />
              <div className='scrollable-y'>
                <div className="heading2">Invite co-author</div>
                <form className='form-data'>
                  <p className='label'>First Name *</p>
                  <input className="box" name="fname" onChange={(e) => this.change(e)} />
                  <p className='label'>Lastname</p>
                  <input className="box" name="sname" onChange={(e) => this.change(e)} />
                  <p className='label'>Email *</p>
                  <input className="box" name="email" onChange={(e) => this.change(e)} />
                  <p className='label'>Confirm Email *</p>
                  <input className="box" name="conemail" autocomplete="nofill" onChange={(e) => this.change(e)} />
                  <p className='label'>Title of Paper *</p>
                  <input className="box" name="title" value={this.state.title} onChange={(e) => this.change(e)} />
                  <p className='label'>Message (if any)</p>
                  <textarea rows={6} name="body" onChange={(e) => this.change(e)} />
                  <div className="save-btn" type="button" placeholder="Button" onClick={() => this.inviteco()} >Add</div>
                </form>
              </div>
            </div> : ""}

        </div>
        <Footer />
      </div>
    )
  }
}
export default EditWork;